import { Box, Image, Tooltip } from '@mantine/core';

export interface InputImageProps {
  picture: string;
  onPictureClick?(): void;
  screenshotLink?: string;
  disabled?: boolean;
  tooltip?: string;
}

export const InputImage: React.FC<InputImageProps> = (props) => {
  const icon = (
    <Box
      component="div"
      style={{
        cursor: !!props?.onPictureClick && !props.disabled ? 'pointer' : 'default',
      }}
      onClick={() => !props.disabled && props.onPictureClick?.()}
    >
      <Image src={props.picture} alt={props.tooltip || 'web service'} fit="contain" w={20} h={20} opacity={1} />
    </Box>
  );

  if (!props.tooltip) {
    return icon;
  }

  return (
    <Tooltip label={props.tooltip} withinPortal withArrow position="top">
      {icon}
    </Tooltip>
  );
};
